<template>
<div>
  <div>
    <components :is="statusComponents"></components>
  </div>
  <div class="block lg:flex container">
    <div class="rounded-sm bg-grey-lightest lg:bg-white px-8 py-4 lg:p-0 w-full lg:w-1/3" style="min-width: 295px;">
      <div class="sticky">
        <h1 class="font-bold text-lg leading-lg">{{ $t('recommendLocation' )}}</h1>
        <div class="font-bold text-xs leading-sm mb-8">{{ $t('mostCustomerSelectThisLocation' )}}</div>
        <scrollactive :offset="180" :modifyUrl="false" :highlightFirstItem="true" class="mt-16 mb-24 border-b border-grey-lighter">
          <a v-for="item in list.countyData" :key="item.id" :href="`#field-${item.id}`" class="no-underline border-t-1 border-grey-lighter p-8 flex items-center justify-between cursor-pointer ease scrollactive-item">
            <div>
              <div class="font-bold text-sm leading-sm mb-4">{{ item.name }}</div>
              <div class="text-xs text-grey-darker">{{ item.administrativeAreaName }}</div>
            </div>
            <div class="text-xs text-grey-darker"> {{ $t('items', [item.count]) }}</div>
          </a>
        </scrollactive>
        <!-- 暫時隱藏 -->
        <!-- <div>
          <div class="text-xs font-bold mb-8">{{ $t('useMapToFind') }}</div>
          <router-link to="/map" class="no-underline text-grey-darkest w-full rounded-sm flex items-center justify-center border-1 border-grey-light ease hover:border-blue-light" :style="`height: 150px; background: url('${mapImage}') center;`">
            <i class="owl-location text-red text-xl"/>
            <span class="font-bold">{{ $t('lookHotelAtMap') }}</span>
          </router-link>
        </div> -->
      </div>
    </div>
    <div class="flex-auto ml-8">
      <section class="section-event">
        <h2 class="text-lg font-bold mx-8">{{ $t('eventBlock') }}</h2>
        <div class="flex flex-wrap">
          <template v-for="(item, index) in list.events">
            <router-link v-if="index < 3" :to="{name: 'Event', params: {eventId: item.alias} }" :key="item.alias" class="w-full sm:w-1/2 lg:w-1/3 eventCard">
              <div class="m-8 rounded-sm overflow-hidden">
                <div class="eventCard__cover" v-lazy:background-image="item.imageUrl ? item.imageUrl : require('@/assets/images/default-event.jpg')"></div>
                <div class="my-4 font-bold text-base leading-md title"><v-clamp autoresize :max-lines="1">{{ item.title }}</v-clamp></div>
                <div class="text-sm text-grey-darker leading-md subject">{{ item.subject }}</div>
              </div>
            </router-link>
          </template>
        </div>
      </section>
      <section v-for="item in list.countyData" :key="item.id" :id="`field-${item.id}`" class="section-place mt-32" >
        <div class="m-8">
          <h2 class="text-lg font-bold">{{ item.name }}</h2>
          <div class="text-xs text-grey-dark">{{ item.administrativeAreaName }}</div>
        </div>
        <div class="flex flex-wrap">
          <hotelCard
            class="w-1/2 p-4 md:w-1/3 mb-16"
            v-for="hotel in item.targetData"
            :hotel="hotel"
            :key="hotel.hotelUUID"
            @addFavorite="addFavoriteHandler($event, item.id)"
            @removeFavorite="removeFavoriteHandler($event, item.id)"
          />
        </div>
        <div class="mx-8">
          <div class="more-btn cursor-pointer" @click.prevent.stop="goToMore(item)">{{ $t('readMore') }}</div>
        </div>
      </section>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import hotelCard from '@/components/hotelCardV3.vue'
import notFound from '@/components/status/notFound'
import noData from '@/components/status/noData'
import mapSvg from '@/assets/map-btn-lg.svg'
import VClamp from 'vue-clamp'
export default {
  name: 'recommendList',
  components: {
    hotelCard: hotelCard,
    VClamp
  },
  data () {
    return {
      mapImage: mapSvg,
      list: {}
    }
  },
  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop'
    }),
    statusComponents: function () {
      if (this.$route.name === '404') {
        return notFound
      } else {
        if (this.$route.query?.search) {
          return noData
        }

        return ''
      }
    }
  },
  methods: {
    ...mapActions({
      fetchDefaultSearchList: 'hotels/fetchDefaultSearchList',
      'user/addFavorite': 'user/addFavorite',
      'user/removeFavorite': 'user/removeFavorite'
    }),
    goToMore: function (item) {
      event.stopPropagation()
      const query = {
        search: item.name,
        searchId: item.id,
        searchType: item.type,
        start: this.$route.query.start,
        end: this.$route.query.end,
        room: this.$route.query.room || 1,
        adult: this.$route.query.adult || 2,
        child: this.$route.query.child,
        ages: this.$route.query.ages
      }

      if (!query.start || !query.end) {
        if (this.$searchMobileModal) {
          this.$searchMobileModal.toggle()
          this.$searchMobileModal.set({
            inputValue: item.name,
            selected: item,
            list: []
          })
        }
        if (this.$searchBar) {
          this.$searchBar.$refs.searchPlaceInput.inputValue = item.name
          this.$searchBar.$refs.searchPlaceInput.selected = item
          this.$searchBar.submitSearchData()
        }
      } else {
        this.$router.replace({
          name: 'HotelsList',
          query
        })
      }
    },
    addFavoriteHandler: function (hotel, countyId) {
      this['user/addFavorite'](hotel.hotelUUID)
        .then(res => {
          if (res) {
            const county = _.find(this.list.countyData, county => county.id === countyId)
            const targetHotel = _.find(county.targetData, target => target.hotelUUID === hotel.hotelUUID)
            targetHotel.isFavorite = true
            this.$message({
              message: this.$t('addItemToFavorite', [hotel.hotelNameLocal]),
              type: 'success'
            })
          }
        })
    },
    removeFavoriteHandler: function (hotel, countyId) {
      this['user/removeFavorite'](hotel.hotelUUID)
        .then(res => {
          if (res) {
            const county = _.find(this.list.countyData, county => county.id === countyId)
            const targetHotel = _.find(county.targetData, target => target.hotelUUID === hotel.hotelUUID)
            targetHotel.isFavorite = false
            this.$message({
              message: this.$t('removeItemFromFavorite', [hotel.hotelNameLocal]),
              type: 'warning'
            })
          }
        })
    }
  },
  created () {
    this.fetchDefaultSearchList().then(res => {
      this.list = res
    })
  }
}
</script>

<style lang="sass" scoped>
.more-btn
  @apply text-blue-light underline font-bold my-8
.sticky
  position: -webkit-sticky
  position: sticky
  top: 180px
.scrollactive-item
  @apply no-underline text-grey-darkest
  &:hover
    @apply bg-blue-lightest
  &.is-active
    @apply text-blue
.eventCard
  @apply no-underline
  &__cover
    padding-top: imageRatio(397, 260)
    background:
      position: center
      repeat: no-repeat
      size: cover
  .title
    @apply text-grey-darkest
  .subject
    @apply text-grey-darker
</style>
